
    import './styles.scoped.css';
    export default {
  "trigger-button": "awsui_trigger-button_119fv_11zih_5"
};
  